export class ProfileInfo {
  firstname: string;
  lastname: string;
  middleInitial: string;
  dateOfBirth: string;
  businessEmail: string;
  confirmBusinessEmailAddress: string;
  personalEmail: string;
  confirmPersonalEmailAddress: string;
  personalPhoneNumber: string;
  businessPhoneNumber: string;
  addressInUSModel;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: number;
  zipCodeExtension: number;
  socialSecurityNumber: number | string;
  userId: string;
  username: string;
  reproofpwd: string;
  password: string;
  confirmPassword: string;
  customproperty1: string;
  experianReferenceId: string;
  ecp1: string;
  ecp2: string;
  customproperty39: string;
  customproperty38: any;
  customproperty36: string;
  farsStatusCode: string;
  captchaToken: string;
  captcha?: string;
  country: string;
  manualProofing: boolean;
  customproperty16: string;
  reproofingFlow = false;
  customproperty41: number;
  reproofdob: string;
  loa3Flow: string;
  accountid: string;
  sourceType: string;
  loaStatus: string;
  pwd: string;
  customproperty64: string;
  cmsByPassFlow = false;
  hdim: string;
  jsc: string;
}
